import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const reports = () => {
  const auth = useAuth();

  async function summary(from, to, storeId = null) {
    let retorno;
    try {
      const params = {from, to};
      if (storeId) params.store_id = storeId;
      const {data} = await http.get('/reports/summary', {...auth.getBearer(), params});
      retorno = data;
    } catch (error) {
      console.log(error?.response?.data);
    }
    return retorno;
  }

  return {summary}
}
